module.exports = __webpack_public_path__ + "static/img/SK.1259af8b.png";